import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconInfo } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { arePollsDisabled } from '../../../conference/functions.any';
import { toggleSidePanelApp } from '../../../side-panel/actions';
import { SidePanelTabId } from '../../../side-panel/constants';
import { isSidePanelTabOpen } from '../../../side-panel/functions';
/**
 * Component that renders a button to open the polls panel.
 *
 * @augments AbstractButton
 */
class PollsButton extends AbstractButton {
    icon = IconInfo;
    label = 'toolbar.polls';
    tooltip = 'toolbar.polls';
    /**
     * {@inheritdoc}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Handles clicking the button to open the polls panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        dispatch(toggleSidePanelApp(SidePanelTabId.POLLS));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {Object} - Mapped props.
 */
function mapStateToProps(state) {
    return {
        _isOpen: isSidePanelTabOpen(state, SidePanelTabId.POLLS),
        visible: !arePollsDisabled(state)
    };
}
export default translate(connect(mapStateToProps)(PollsButton));
